import React from 'react';

import { cssMap, cx } from '@atlaskit/css';
import { Inline } from '@atlaskit/primitives/compiled/inline';
import { Stack } from '@atlaskit/primitives/compiled/stack';
import { Text } from '@atlaskit/primitives/compiled/text';
import { token } from '@atlaskit/tokens';

import type { ProjectHighlightElement } from '../../../dynamic-layout-parser/types/dynamic-layout-section';

interface ProjectHightlightCardComponentProps {
	component: ProjectHighlightElement;
}

const styles = cssMap({
	container: {
		paddingTop: token('space.200'),
		paddingRight: token('space.200'),
		paddingBottom: token('space.200'),
		paddingLeft: token('space.200'),
		borderColor: token('color.border'),
		borderWidth: token('border.width'),
		borderStyle: 'solid',
		borderRadius: token('radius.large'),
	},
	summaryBox: {
		maxWidth: '220px',
	},
});

export const DynamicLayoutProjectHighlightCard = ({
	component,
}: ProjectHightlightCardComponentProps): React.JSX.Element | null => {
	const title = component?.attributes?.title || '';
	const text = component?.attributes?.content || '';

	return title || text ? (
		<Inline xcss={cx(styles.container)} space="space.200" alignBlock="center">
			<Stack space="space.050" xcss={styles.summaryBox}>
				{title && (
					<Text weight="bold" size="medium" maxLines={1}>
						{title}
					</Text>
				)}
				{text && (
					<Text color="color.text.subtlest" maxLines={1}>
						{text}
					</Text>
				)}
			</Stack>
		</Inline>
	) : null;
};
